<template>
    <div>
        <div class="toolbar">
            <el-form :inline="true" :model="q" size="mini">
                <el-form-item label="账号ID:">
                     <el-input v-model="q.id" placeholder="账号ID" prefix-icon="el-icon-edit"></el-input>
                </el-form-item>
                <el-form-item label="账号名称:">
                    <el-input v-model="q.user_name" placeholder="账号名称" prefix-icon="el-icon-edit"></el-input>
                </el-form-item>
                <el-form-item label="当前状态">
                    <el-select v-model="q.enable" clearable placeholder="请选择">
                        <el-option label="启用" :value="true"></el-option>
                        <el-option label="禁用" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button type="danger" @click="reload">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-row type="flex" class="row-bg btn-row" justify="end">
            <el-button size="mini" @click="add" type="primary" icon="el-icon-plus">新增账号</el-button>
        </el-row>
        <el-table :data="listData.items" v-loading.body="listLoading" @sort-change="sortlist" size="mini" stripe border
                  fit
                  highlight-current-row>
            <el-table-column prop="id" label='账号ID' width="80"></el-table-column>
            <el-table-column prop="user_name" label='账号名称' width="150"></el-table-column>
            <el-table-column prop="role" label='账号类型' width="150" :formatter="typeFormartter"></el-table-column>
            <el-table-column label='IP白名单' prop="white_ips" width="150">
                <template slot-scope="scope">
                    <div v-for="item in scope.row.white_ips" :key="item">{{item}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="enable" label='当前状态' width="100" :formatter="typeFormartter"></el-table-column>
            <el-table-column prop="remark" label='备注'></el-table-column>
            <el-table-column prop="created_at" label='创建时间' sortable width="180"></el-table-column>
            <el-table-column prop="updated_at" label='更新时间' sortable width="180"></el-table-column>
            <el-table-column label="操作" width="260" fixed="right">
                <template slot-scope="scope">
                    <div>
                        <el-button type="success" size="mini" @click="resetPwd(scope.row)">重置密码</el-button>
                        <el-button type="danger" size="mini" @click="resetOTP(scope.row)">重置OTP</el-button>
                        <el-button type="primary" size="mini" @click="update(scope.row)">编辑</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="q.page_no" :page-sizes="$store.state.app.pageSizeArr"
                           :page-size="q.page_size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="listData.total">
            </el-pagination>
        </div>
        <save-update v-if="showUpdate" :showUpdate.sync="showUpdate" :id="show_id" ></save-update>
    </div>
</template>

<script>
    import saveUpdate from './saveUpdate'
    import {getAgencyOperator, resetPasswordAgencyOperator, resetVcodeSecretAgencyOperator} from '@/api'
    import {useVcode} from "../../utils/CommonJs";

    export default {
        components: {saveUpdate},
        data() {
            return {
                listData: {},
                q: {page_size: 30, page_no: 1},
                listLoading: false,
                showUpdate: false,
                show_id: null,
                resetPwdMeg: false,
                vcode: ''
            }
        },
        activated() {
            this.getList()
        },
        created(){
           
        },
        deactivated() {
            this.listLoading = false
        },
        methods: {
            add() {
                if (this.resetPwdMeg) {
                    this.resetPwdMeg.close();
                }
                this.show_id = null
                this.showUpdate = true
            },
            resetPwd(row) {
                this.$confirm(`是否确认重置密码？`, '重置密码', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    useVcode(this,()=>{
                        if (this.resetPwdMeg) {
                            this.resetPwdMeg.close();
                        }
                        resetPasswordAgencyOperator(row.id).then(res => {
                            if (res.status === 0) {
                                let msg = '重置密码成功，' + '密码为：' + res.data.password
                                this.resetPwdMeg = this.$message({
                                    type: 'success',
                                    message: msg,
                                    duration: 10000,
                                    showClose: true
                                })
                            }
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            resetOTP(row) {
                this.$confirm(`是否确认重置OTP？`, '重置OTP', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    useVcode(this,()=>{
                        if (this.resetPwdMeg) {
                            this.resetPwdMeg.close();
                        }
                        resetVcodeSecretAgencyOperator(row.id).then(res => {
                            if (res.status === 0) {
                                let msg = '重置OTP成功'
                                this.resetPwdMeg = this.$message({
                                    type: 'success',
                                    message: msg,
                                    duration: 10000,
                                    showClose: true
                                })
                            }
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            update(row) {
                if (this.resetPwdMeg) {
                    this.resetPwdMeg.close();
                }
                this.show_id = row.id
                this.showUpdate = true
            },
            query() {
                this.q = {...this.q, ...{page_no: 1, page_size: 30}}
                if(!this.q.id) delete this.q.id
                if(!this.q.user_name) delete this.q.user_name
                this.getList()
            },
            reload() {
                this.q = {page_size: 30, page_no: 1}
                this.getList()
            },
            sortlist(sort) {
                this.q.$orderby = sort.prop
                this.getList()
            },
            handleSizeChange(val) {
                this.q.page_size = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.q.page_no = val
                this.getList()
            },
            getList() {
                if (this.resetPwdMeg) {
                    this.resetPwdMeg.close();
                }
                for(let key in this.q){
                    if(this.q[key] === ''){
                        delete this.q[key];
                    }
                }
                getAgencyOperator(this.q).then(res => {
                    if (res.status === 0) {
                        this.listLoading = false
                        this.listData = res.data
                        this.listData.items = Array.from(res.data.items, x => Object.assign({}, x, {warning_amount: Number(x.warning_amount) / 100}))
                    }
                })
            },
          
            typeFormartter(row, column) {
                let columnName = column.property
                if (columnName === 'enable') {
                    return row.enable ? '启用' : '禁用'
                } else if (columnName === 'working') {
                    return row.working ? '工作中' : '休息中'
                } else if (columnName === 'mchs') {
                    let mchsList = []
                    row.mchs.forEach(item => {
                        mchsList.push(item.name)
                    })
                    return mchsList.toString()
                }
                else if(columnName === 'role'){
                    return this.$store.state.app.agencyOperatorRole[row.role];
                }
                else if(columnName === 'user_level'){
                    return this.$store.state.app.UserLevel[row.user_level]
                }
            }
        },
        watch: {
            showUpdate() {
                if (!this.showUpdate) {
                    this.getList()
                }
            }
        }
    }
</script>
